// extracted by mini-css-extract-plugin
module.exports = {"container":"single-module--container--SN_Wc","footer":"single-module--footer--qf8_v single-module--container--SN_Wc"};